// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3azx3","unreadBadge":"styles_unreadBadge__HREkq","modalContent":"styles_modalContent__xGEjL","modal":"styles_modal__1v-hf"};